import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin, ClienteVAM, UsuarioVamTit } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";
import { VamTitularesService } from './vam-titulares.service';
import { VamTitularEntity, TitularVam } from './entities/vam_titulares_entity';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { log } from 'util';

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
    selector: 'vamTittular',
    providers: [VamTitularesService],
    templateUrl: 'vam-impuestoRenta.template.html',
    styleUrls: ["vam-titulares.style.css"]
    
})
export class vamImpuestoRenta  implements OnInit {
    usuario: ClienteLogin;
    vamTitular:VamTitularEntity;
    titular:TitularVam;
    //clienteVam: ClienteVAM;
    usuarioVam: UsuarioVamTit;
    NombreUsuario: string;

    constructor( 
        private vamTitularesService: VamTitularesService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private sesionStorageService: SessionStorageService,
        private consultarVAM: ConsultarUsuarioVAM
    ) {
        
    }

    ngOnInit(): void {

        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.consultarVAM.iniciarUsuarioVAM();

        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {

                this.usuarioVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
                this.titular = new TitularVam();

                this.titular.Cedula = this.usuario.Cedula;
                this.titular.CodigoCiudad = this.usuarioVam.CodigoCiudad;
                this.titular.CodigoCliente = this.usuarioVam.CodigoCliente;                
                                
                try{
                    this.NombreUsuario = jQuery.parseJSON(this.sesionStorageService.retrieve("NombreUser"));
                }catch(e){
                    this.NombreUsuario = this.sesionStorageService.retrieve("NombreUser");
                }


                this.titular.NombreTitular = this.NombreUsuario;

                /*
                this.consultarVAM.iniciarUsuarioVAM();
                this.vamTitular = new VamTitularEntity();                
                    this.vamTitularesService.ConsultarDatosVamTitular().subscribe(
                    datosTitular => {
                    this.vamTitular = datosTitular;
                      
                    },
                    error => { this.handleError.redirectUrl(error); });
                */
            }
        }
    }

    GenerarReporteImpuestoRenta(e) {
        e.preventDefault();
        this.vamTitularesService.generarReporteImpuestoRenta(this.titular).subscribe(result => {
            let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });

            var a = document.createElement("a");

            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "impuestoALaRenta" + ".pdf";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, "certificado" + ".pdf");
            }
            else {
                a.click();
                window.URL.revokeObjectURL(url);
            }

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            }
            /*let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf'must match the Accept type
            });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            }*/
            swal("La descarga se realizo correctamente");
        }, error => { this.handleError.redirectUrl(error); });
    }

    
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/vam-impuestoRenta.component.ts